

















import breakpoints from 'library/assets/vars/breakpoints'
import { mergeShopifyProductCards } from 'library/helpers/products'
import getCategoryProducts from '~/queries/get-category-products.gql'
import ProductCard from '../globals/cards/product/product-card'

export default
	components: {
		ProductCard
	}

	props: block: Object

	data: ->
		products: []
		currentSlide: 0

		config:
			slidesPerPage: 4
			showDots: true
			gutter: 'var(--gutter)'
			peekLeft: 'var(--gutter)'
			peekRight: 'var(--peek-right)'

			responsive: [
				{
					minWidth: parseInt(breakpoints.desktop) + 1
					feather: 'var(--gutter)'
				}
				{
					maxWidth: parseInt breakpoints['tablet-landscape']
					slidesPerPage: 3
				}
				{
					maxWidth: parseInt breakpoints.tablet
					slidesPerPage: 2
				}
				{
					maxWidth: parseInt breakpoints.mobile
					slidesPerPage: 1
				}
			]

	fetch: ->
		# If no categories provided, then use the manually listed products.
		unless @categories.length then products = @block.products

		# If categories were provided, then fetch the matching products.
		else
			categoryIds = @categories.map (category) -> parseInt category.id
			products = await @$craft.getEntries
				query: getCategoryProducts
				variables: category: ['and', ...categoryIds]

		# Fetch product data from Shopify
		products = await mergeShopifyProductCards products

		# Wait to overwrite existing @products (and re-render the front end) until we're done fetching
		@products = products

	computed:
		categories: -> @block.categories

	methods:
		slideUpdate: ({index}) -> @currentSlide = index

	watch:
		# When the products change, we have to merge Shopify data again.
		'block.products': -> @$fetch()

